var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 30"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 30,
  fill: "#000",
  rx: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.625 20.748c-.02.359-.206.686-.498.881L20.5 27.378c-.275.163-.723.163-.998 0l-9.628-5.749c-.276-.163-.498-.554-.498-.881V9.253c.02-.36.203-.687.498-.882L19.5 2.623c.275-.164.723-.164.998 0l9.628 5.748c.275.16.498.554.498.882z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#twint_svg__a)",
  d: "m25.023 15.026-2.519 3.81-1.284-2.033 1.482-2.29c.276-.409.865-1.534.184-3.064a3.08 3.08 0 0 0-2.796-1.844c-1.049 0-2.189.554-2.807 1.844-.695 1.479-.092 2.63.17 3.023l1.51 2.305 1.116 1.668 1.678 2.657c.013.013.274.432.747.432.445 0 .721-.419.763-.46l3.933-6.02h-2.177zm-4.944.095-1.09-1.749c-.46-.772.052-1.923 1.09-1.923 1.034 0 1.546 1.15 1.088 1.923z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#twint_svg__b)",
  d: "m17.665 18.715-2.468-3.58-1.088-1.749c-.459-.772.053-1.926 1.088-1.926.13 0 .25.014.367.055l.868-1.64a3 3 0 0 0-1.221-.273c-1.049 0-2.192.557-2.807 1.847-.695 1.476-.092 2.63.17 3.023l4.318 6.603c.038.052.314.474.773.474.458 0 .72-.408.762-.462l1.296-2.047-1.113-1.694z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "twint_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(11.6017 0 0 13.5165 19.26 10.65)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#FFC800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.174,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.253,
  stopColor: "#FFAB00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#FF9100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.405,
  stopColor: "#FF7000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.479,
  stopColor: "#FF4700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#FF1800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.582,
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "red"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "twint_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(10.6381 0 0 16.6244 12.267 11.339)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B4E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.201,
  stopColor: "#00B0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#01A5DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.574,
  stopColor: "#0292CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.755,
  stopColor: "#0377BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.932,
  stopColor: "#0455A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#054696"
})))));
export default SvgTwint;